import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const uploadStudentExcelData = createAsyncThunk(
    'excel/uploadStudentExcelData',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/uploads/excel/students', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error en la carga del archivo');
        }
    }
);

const initialState = {
    success: null,
    process: false,
    error_message: null,
};

const excelSlice = createSlice({
    name: 'data_students_excel',
    initialState: {
        success: null,
        process: false,
        error_message: null,
    },
    reducers: {
        resetState: () => initialState,  // Reducer para restablecer el estado inicial
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadStudentExcelData.pending, (state) => {
                state.process = true;
                state.error_message = null;
            })
            .addCase(uploadStudentExcelData.fulfilled, (state, action) => {
                state.process = false;
                state.success = action.payload;
            })
            .addCase(uploadStudentExcelData.rejected, (state, action) => {
                state.process = false;
                state.error_message = action.payload;
            });
    },
});

export const { resetState } = excelSlice.actions; // Exportar el nuevo reducer
export default excelSlice.reducer;
